import React from 'react';
import { css } from 'react-emotion';
import { LoadingLine } from '@jetshop/ui/Loading/LoadingLine';
import PageHeader from '../Layout/PageHeader/PageHeader';
import PageHeaderLoadingState from '../Layout/PageHeader/PageHeaderLoadingState';
import DynamicContentWrapper from './DynamicContentWrapper';
import { Heading, Subheading, MaxWidth } from './ContentComponents';
import { theme } from '../Theme';

const containerStyling = css`
  margin-top: 4.25rem;
  margin-bottom: 12rem;
  *:first-child {
    margin-top: 0;
  }
  ${theme.below.md} {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }
`;

const additionalComponents = {
  heading: props => <Heading Tag="h2" {...props} />,
  subheading: props => <Subheading Tag="h3" {...props} />
};

function ContentPage(props) {
  const { result, cacheHit } = props;
  const { name, parents, content } = result?.data?.route?.object || {};

  return (
    <>
      {cacheHit ? (
        <PageHeader
          cacheHit={cacheHit}
          title={name}
          parents={parents}
          breadcrumbText={name}
        />
      ) : (
        <PageHeaderLoadingState />
      )}
      <div className={containerStyling}>
        {cacheHit ? (
          <DynamicContentWrapper
            content={content}
            additionalComponents={additionalComponents}
          />
        ) : (
          <MaxWidth>
            <LoadingLine
              heightPx={14}
              widthRem={30}
              randomizeWidthBy={10}
              count={10}
              className={css`
                margin-bottom: 12px;
              `}
            />
          </MaxWidth>
        )}
      </div>
    </>
  );
}

export default ContentPage;
